import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CircleAlert, Info } from "lucide-react";
import { useId } from "react";
import { Icon } from "../icons.js";
export function Field({ label, error, note, children }) {
    const id = useId();
    const messageId = `${id}-message`;
    const message = error ? { kind: "error", text: error } : note ? { kind: "note", text: note } : null;
    const invalid = message?.kind === "error";
    return (_jsxs("div", { "data-form-field": "", style: { display: "flex", flexDirection: "column" }, children: [_jsx("label", { htmlFor: id, style: {
                    marginBottom: "var(--space-075)", color: "var(--ink-1)",
                    fontSize: "var(--type-small-size)", lineHeight: "var(--type-small-line)",
                    fontWeight: "var(--type-small-weight-strong)",
                }, children: label }), children({ id, "aria-invalid": invalid ? true : undefined, "aria-describedby": message ? messageId : undefined }, invalid), message && (_jsxs("span", { id: messageId, "data-field-message": message.kind, style: {
                    display: "flex", alignItems: "center", gap: "var(--space-075)", marginTop: "var(--space-075)",
                    color: message.kind === "error" ? "var(--ink-1)" : "var(--ink-2)",
                    fontSize: "var(--type-small-size)", lineHeight: "var(--type-small-line)",
                    fontWeight: message.kind === "error" ? "var(--type-small-weight-strong)" : "var(--type-small-weight)",
                }, children: [_jsx("span", { style: {
                            display: "inline-flex", flex: "none",
                            color: message.kind === "error" ? "var(--problem)" : "var(--ink-2)",
                        }, children: _jsx(Icon, { icon: message.kind === "error" ? CircleAlert : Info, size: 15, "aria-hidden": "true" }) }), message.text] }))] }));
}
/** The control box both form controls share: 36 tall, radius 6, `--tone`; errored, the inset edge. */
function box(invalid) {
    return {
        display: "flex", alignItems: "center", position: "relative", height: 36,
        borderRadius: "var(--radius-control)",
        background: invalid ? "var(--sheet)" : "var(--tone)",
        boxShadow: invalid ? "inset 0 0 0 1.5px var(--problem)" : "none",
    };
}
const control = {
    flex: 1, minWidth: 0, height: "100%", background: "transparent", border: "none", outline: "none",
    color: "var(--ink-1)", fontFamily: "var(--font-sans)",
    fontSize: "var(--type-body-size)", lineHeight: "var(--type-body-line)",
};
/**
 * A text input in a form (design-spec §2 "Name and Email inputs"): the `Field` around a
 * full-width box. The box carries `data-field`, so `interactions.css` draws the focus ring on
 * it while the input has focus (as `Input`'s), and `data-invalid` while it shows an error.
 */
export function TextField({ label, error, note, style, ...input }) {
    return (_jsx(Field, { label: label, error: error, note: note, children: (props, invalid) => (_jsx("div", { "data-field": "", "data-text-field": "", "data-invalid": invalid ? "" : undefined, style: { ...box(invalid), padding: "0 var(--space-15)", ...style }, children: _jsx("input", { ...input, ...props, style: control }) })) }));
}
